import React from 'react';

const StatCard = ({ title, value, subtitle, color }) => (
    <div className="bg-white rounded-lg shadow p-6">
        <p className="text-sm font-medium text-gray-500">{title}</p>
        <p className={`text-2xl font-bold mt-1 ${color || 'text-gray-900'}`}>{value}</p>
        {subtitle && <p className="text-xs text-gray-400 mt-1">{subtitle}</p>}
    </div>
);

export default function SummaryCards({ summary }) {
    if (!summary) return null;

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
            <StatCard
                title="Restock Alerts"
                value={summary.totalRestockAlerts}
                color="text-orange-600"
            />
            <StatCard
                title="Excess Inventory"
                value={summary.excessInventoryCount}
                subtitle={summary.excessInventoryCost != null ? `$${Number(summary.excessInventoryCost).toFixed(2)}/mo storage` : ''}
                color="text-red-600"
            />
            <StatCard
                title="BB Status"
                value={summary.bbStatusCount}
                color="text-purple-600"
            />
            <StatCard
                title="MP Pros Losing"
                value={summary.mpLosingCount}
                subtitle="ASINs where they win"
                color="text-blue-600"
            />
            <StatCard
                title="High Returns"
                value={summary.highReturnCount}
                subtitle=">15% return rate"
                color="text-yellow-600"
            />
        </div>
    );
}
